export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Oh My Bakery",
  headline: "About Us",
  description:
    "We are a family in Winnipeg that began this business in 2017. When we began the business, we just wanted to try it out with family and friends to see what they thought of the cakes, and we sold out on the first day which was a sign for us to continue the business and most importantly deliver quality cakes. We love the fact that we put smiles on people's faces when they pick up their cakes.",
  imgStart: false,
  alt: "Cake",
  dark: true,
  primary: true,
  darkText: false,
};
